<template>
  <div class="hodo-navbar">
    <nav class="navbar navbar-expand-lg navbar-light bg-white pb-0 pr-0">
      <div class="brand-wraper border-bottom sidebar-toggle" :class="extraSidebar && !isMobile ? 'justify-content-start open' : 'justify-content-center'">
        <template v-if="$globalClinic || (userOrg && userOrg.logo && appMode === 1) || $globalOrg">
          <el-dropdown class="w-100" @command="switchMode">
            <div class="navbar-brand relative w-full cursor-pointer" :class="extraSidebar && !isMobile ? '' : 'd-flex ml-2 align-items-center'" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-if="isDoctor">
              <!-- clinic -->
              <div>
                <span v-if="$globalClinic && $globalClinic.avatar && appMode === 1" class="avatar avatar-sm" :style="'background-image: url(' + getImageURL($globalClinic.avatar) + ')'"></span>
                <span v-if="$globalClinic && !$globalClinic.avatar && appMode === 1" class="avatar avatar-sm text-white bg-pri">
                  {{ $globalClinic && $globalClinic.name ? $globalClinic.name.charAt(0) : "" }}
                </span>
              </div>
              <div class="ml-2 flex-1 w-1 transition-all duration-300" :class="extraSidebar && !isMobile ? 'visible opacity-100 h-auto' : 'invisible opacity-0 h-0 overflow-hidden'" v-if="$globalClinic && appMode === 1">
                <p class="fs-15 fw-700 txt-grey-600 text-truncate mb-0 transition-all duration-300" :class="extraSidebar && !isMobile ? 'visible opacity-100 h-auto' : 'invisible opacity-0 h-0 overflow-hidden'">
                  {{ $globalClinic.organization ? $globalClinic.organization.name : $globalClinic.org_name || "" }}
                </p>
                <p class="fs-13 font-bold txt-pri mb-0 text-truncate transition-all duration-300" :class="extraSidebar && !isMobile ? 'visible opacity-100 h-auto' : 'invisible opacity-0 h-0 overflow-hidden'">
                  {{ $globalClinic ? $globalClinic.name : "" }}
                </p>
              </div>
              <!-- clinic -->

              <!-- org -->
              <div>
                <span v-if="(userOrg && userOrg.logo && appMode === 2) || (!$globalClinic && userOrg && userOrg.logo && appMode === 1)" class="avatar avatar-sm" :style="'background-image: url(' + getImageURL(userOrg.logo) + ')'"></span>
                <span v-if="(userOrg && !userOrg.logo && appMode === 2) || (!$globalClinic && userOrg && userOrg.id && !userOrg.logo && appMode === 1)" class="avatar avatar-sm text-white bg-pri">{{ userOrg && userOrg.name ? userOrg.name.charAt(0) : "" }}</span>
              </div>
              <div class="ml-2 flex-1 w-1 transition-all duration-300" :class="extraSidebar && !isMobile ? 'visible opacity-100 h-auto' : 'invisible opacity-0 h-0 overflow-hidden'" v-if="(userOrg && appMode === 2) || (!$globalClinic && userOrg && userOrg.id && appMode === 1)">
                <p class="fs-13 fw-500 txt-grey-600 text-truncate mb-0 transition-all duration-300">
                  {{ $t("side_menu.lbl_organization") }}
                </p>
                <p class="fs-15 fw-700 txt-pri text-truncate mb-0 transition-all duration-300">
                  {{ userOrg ? userOrg.name : "" }}
                </p>
              </div>
              <!-- org -->
            </div>
            <el-dropdown-menu slot="dropdown" class="list-ws">
              <template v-if="appMode === 1">
                <el-dropdown-item v-for="w in clinics" :key="w.id + 'ws'" class="mb-1 fw-500 fs-16 max-line-1" :class="$globalClinic && w.id === $globalClinic.id ? 'txt-pri' : 'txt-black'" :command="w">
                  <span class="avatar mr-2">
                    <span class="avatar">
                      {{ w.name ? w.name.charAt(0) : "" }}
                    </span>
                  </span>
                  {{ w.name }}
                </el-dropdown-item>
              </template>
              <template v-if="appMode === 2">
                <el-dropdown-item v-for="memberOrg in $user.members" :key="memberOrg.id + 'ws'" class="mb-1 fw-500 fs-16 max-line-1" :class="$globalOrg && memberOrg.org_id === $globalOrg.id ? 'txt-pri' : 'txt-black'" :command="memberOrg">
                  <span class="avatar mr-2">
                    <span class="avatar">
                      {{ memberOrg.org.name ? memberOrg.org.name.charAt(0) : "" }}
                    </span>
                  </span>
                  {{ memberOrg.org.name }}
                </el-dropdown-item>
              </template>

              <div class="row none-hover w-500px m-3 mb-2" v-if="appMode === 1">
                <div class="col-4">
                  <div @click="createClinic()" class="cursor-pointer txt-black" href="javascript:;">
                    <svg width="20" height="20" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-1">
                      <path d="M20.5835 11H14.0835V5C14.0835 4.73478 13.9694 4.48043 13.7662 4.29289C13.563 4.10536 13.2875 4 13.0002 4C12.7128 4 12.4373 4.10536 12.2341 4.29289C12.031 4.48043 11.9168 4.73478 11.9168 5V11H5.41683C5.12951 11 4.85396 11.1054 4.6508 11.2929C4.44763 11.4804 4.3335 11.7348 4.3335 12C4.3335 12.2652 4.44763 12.5196 4.6508 12.7071C4.85396 12.8946 5.12951 13 5.41683 13H11.9168V19C11.9168 19.2652 12.031 19.5196 12.2341 19.7071C12.4373 19.8946 12.7128 20 13.0002 20C13.2875 20 13.563 19.8946 13.7662 19.7071C13.9694 19.5196 14.0835 19.2652 14.0835 19V13H20.5835C20.8708 13 21.1464 12.8946 21.3495 12.7071C21.5527 12.5196 21.6668 12.2652 21.6668 12C21.6668 11.7348 21.5527 11.4804 21.3495 11.2929C21.1464 11.1054 20.8708 11 20.5835 11Z" fill="black" />
                    </svg>
                    {{ $t("workspace_setting.lbl_add_ws")[$orgModel] }}
                  </div>
                </div>
                <div class="col-5">
                  <div @click="joinClinic()" class="cursor-pointer txt-black" href="javascript:;">
                    <svg width="20" height="20" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-1">
                      <path d="M20.5835 11H14.0835V5C14.0835 4.73478 13.9694 4.48043 13.7662 4.29289C13.563 4.10536 13.2875 4 13.0002 4C12.7128 4 12.4373 4.10536 12.2341 4.29289C12.031 4.48043 11.9168 4.73478 11.9168 5V11H5.41683C5.12951 11 4.85396 11.1054 4.6508 11.2929C4.44763 11.4804 4.3335 11.7348 4.3335 12C4.3335 12.2652 4.44763 12.5196 4.6508 12.7071C4.85396 12.8946 5.12951 13 5.41683 13H11.9168V19C11.9168 19.2652 12.031 19.5196 12.2341 19.7071C12.4373 19.8946 12.7128 20 13.0002 20C13.2875 20 13.563 19.8946 13.7662 19.7071C13.9694 19.5196 14.0835 19.2652 14.0835 19V13H20.5835C20.8708 13 21.1464 12.8946 21.3495 12.7071C21.5527 12.5196 21.6668 12.2652 21.6668 12C21.6668 11.7348 21.5527 11.4804 21.3495 11.2929C21.1464 11.1054 20.8708 11 20.5835 11Z" fill="black" />
                    </svg>
                    {{ $t("workspace_setting.lbl_join_ws")[$orgModel] }}
                  </div>
                </div>
                <div class="col-3">
                  <a class="cursor-not-allowed txt-black" href="javascript:;">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-1">
                      <path
                        d="M10 13H3C2.73478 13 2.48043 13.1054 2.29289 13.2929C2.10536 13.4804 2 13.7348 2 14V21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8946 2.73478 22 3 22H10C10.2652 22 10.5196 21.8946 10.7071 21.7071C10.8946 21.5196 11 21.2652 11 21V14C11 13.7348 10.8946 13.4804 10.7071 13.2929C10.5196 13.1054 10.2652 13 10 13ZM9 20H4V15H9V20ZM21 2H14C13.7348 2 13.4804 2.10536 13.2929 2.29289C13.1054 2.48043 13 2.73478 13 3V10C13 10.2652 13.1054 10.5196 13.2929 10.7071C13.4804 10.8946 13.7348 11 14 11H21C21.2652 11 21.5196 10.8946 21.7071 10.7071C21.8946 10.5196 22 10.2652 22 10V3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2ZM20 9H15V4H20V9ZM21 13H14C13.7348 13 13.4804 13.1054 13.2929 13.2929C13.1054 13.4804 13 13.7348 13 14V21C13 21.2652 13.1054 21.5196 13.2929 21.7071C13.4804 21.8946 13.7348 22 14 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21V14C22 13.7348 21.8946 13.4804 21.7071 13.2929C21.5196 13.1054 21.2652 13 21 13ZM20 20H15V15H20V20ZM10 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V10C2 10.2652 2.10536 10.5196 2.29289 10.7071C2.48043 10.8946 2.73478 11 3 11H10C10.2652 11 10.5196 10.8946 10.7071 10.7071C10.8946 10.5196 11 10.2652 11 10V3C11 2.73478 10.8946 2.48043 10.7071 2.29289C10.5196 2.10536 10.2652 2 10 2ZM9 9H4V4H9V9Z"
                        fill="black"
                      />
                    </svg>
                    {{ $t("workspace_setting.lbl_view_all") }}
                  </a>
                </div>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <a
          class="navbar-brand ml-2"
          href="javascript:;"
          @click="
            () => {
              $router.push({ name: 'HomePage' })
            }
          "
          v-if="!isDoctor"
        >
          <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
            <path d="M8.88006 26.4129L2.25869 19.7916C-0.752896 16.78 -0.752896 11.8946 2.25869 8.88006L8.88006 2.25869C11.8916 -0.752896 16.777 -0.752896 19.7916 2.25869L26.4129 8.88006C29.4245 11.8916 29.4245 16.777 26.4129 19.7916L19.7916 26.4129C16.777 29.4245 11.8946 29.4245 8.88006 26.4129Z" fill="#20409B" />
            <path
              d="M14.5038 8.97141C14.7648 8.94795 15.014 8.90104 15.2428 8.82773C15.6504 8.7163 16.0081 8.5169 16.3014 8.25298C16.3424 8.21779 16.3835 8.17673 16.4245 8.13861L16.4392 8.12395C16.9788 7.58439 17.2749 6.82196 17.2309 5.94224C17.1987 5.27952 16.9582 4.69011 16.5741 4.23265C16.4685 4.10362 16.3512 3.98632 16.2222 3.88076C15.7618 3.49368 15.1724 3.25616 14.5097 3.22097C13.671 3.17991 12.9467 3.44383 12.413 3.93354C12.3837 3.95993 12.3573 3.98339 12.3309 4.00978C11.9937 4.33528 11.7444 4.75168 11.6154 5.23846C11.6125 5.25313 11.6066 5.26779 11.6037 5.28245C11.545 5.49065 11.504 5.71352 11.4834 5.94518C11.4834 5.9745 11.4776 6.00382 11.4746 6.03021C11.1609 9.37315 9.4454 11.115 6.13178 11.4581C6.08779 11.464 6.04381 11.4669 5.99983 11.4728C4.31662 11.6252 3.21696 12.766 3.22576 14.3524C3.23163 15.1735 3.54246 15.8772 4.07616 16.3845C4.58346 16.9182 5.28725 17.2261 6.10539 17.232C7.69182 17.2437 8.83253 16.1441 8.98502 14.458C8.98795 14.411 8.99381 14.37 8.99967 14.326C9.33983 11.0094 11.0846 9.29398 14.4276 8.98021C14.4481 8.97728 14.4774 8.97435 14.5038 8.97141Z"
              fill="white"
            />
            <path
              d="M22.7233 17.1902C22.9843 17.1667 23.2335 17.1198 23.4623 17.0465C23.8699 16.935 24.2276 16.7356 24.5209 16.4717C24.5619 16.4365 24.603 16.3955 24.644 16.3574L24.6587 16.3427C25.1982 15.8031 25.4944 15.0407 25.4504 14.161C25.4182 13.4983 25.1777 12.9089 24.7936 12.4514C24.688 12.3224 24.5707 12.2051 24.4417 12.0995C23.9813 11.7124 23.3919 11.4749 22.7292 11.4397C21.8905 11.3987 21.1662 11.6626 20.6325 12.1523C20.6032 12.1787 20.5768 12.2021 20.5504 12.2285C20.2132 12.554 19.9639 12.9704 19.8349 13.4572C19.8319 13.4719 19.8261 13.4865 19.8231 13.5012C19.7645 13.7094 19.7234 13.9323 19.7029 14.1639C19.7029 14.1932 19.697 14.2226 19.6941 14.249C19.3803 17.5919 17.6649 19.3338 14.3513 19.6768C14.3073 19.6827 14.2633 19.6856 14.2193 19.6915C12.5361 19.844 11.4364 20.9847 11.4452 22.5711C11.4511 23.3922 11.762 24.096 12.2956 24.6033C12.803 25.137 13.5067 25.4449 14.3249 25.4508C15.9113 25.4625 17.052 24.3628 17.2045 22.6767C17.2074 22.6298 17.2133 22.5887 17.2192 22.5447C17.5593 19.2282 19.3041 17.5127 22.647 17.199C22.6676 17.196 22.694 17.1931 22.7233 17.1902Z"
              fill="white"
            />
            <path d="M14.3462 17.23C15.9495 17.23 17.2493 15.9302 17.2493 14.3269C17.2493 12.7236 15.9495 11.4238 14.3462 11.4238C12.7429 11.4238 11.4431 12.7236 11.4431 14.3269C11.4431 15.9302 12.7429 17.23 14.3462 17.23Z" fill="white" />
          </svg>
          <span :class="extraSidebar && !isMobile ? 'visible' : 'invisible'" class="fs-20 fw-700 txt-pri text-uppercase">HODO</span>
        </a>
      </div>

      <div v-if="hasUTDOrigin" class="flex px-2 w-14 mt-2">
        <a :href="HodoUTDDomain" target="_blank">
          <img class="m-auto w-full" src="../../assets/images/image1.png" />
        </a>
      </div>
      <!-- Search bar -->
      <el-form v-if="hasUTD" class="el-form flex items-center content-around flex-1" ref="form">
        <div class="flex px-2 w-14">
          <img class="m-auto w-full" src="../../assets/images/image1.png" />
        </div>
        <el-form-item class="mb-0 w-full">
          <el-select ref="upToDateSearch" v-model="selectedAutocompleteValue" @change="handleSetSlugRoute" clearable filterable remote reserve-keyword :placeholder="$t('uptodate.lbl_enter_keyword')" :remote-method="handleChangePage" :loading="loading" class="typing" @input="handleSearchChange" v-shortkey="['ctrl', '/']" @shortkey.native="focusUpToDateSearch">
            <el-option v-for="item in options" :key="item" :label="item" :value="item" />
            <span slot="prefix" class="py-1 px-1 bg-gray-200 text-gray-500 shadow-sm rounded-sm">Ctrl + /</span>
          </el-select>
          <span class="inline-block ml-2">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: scale(-1, 1)">
              <path d="M11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20Z" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M22 22L18 18" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
        </el-form-item>
      </el-form>

      <!-- Search bar -->

      <div class="noti-mode-button ml-auto">
        <div class="flex items-center">
          <div>
            <language :action="true" />
          </div>
          <div class="nav-item group">
            <div class="nav-link cursor-pointer group-hover:text-blue-800 transition-all duration-300 pr-2" @click="goToConversation()">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24Z" fill="#FAFAFA" />
                <path
                  d="M31 20H30V17C30 16.2043 29.6839 15.4413 29.1213 14.8787C28.5587 14.3161 27.7956 14 27 14H17C16.2043 14 15.4413 14.3161 14.8787 14.8787C14.3161 15.4413 14 16.2043 14 17V29C14.001 29.1974 14.0604 29.3901 14.1707 29.5539C14.2811 29.7176 14.4374 29.845 14.62 29.92C14.7387 29.976 14.8688 30.0034 15 30C15.1316 30.0008 15.2621 29.9755 15.3839 29.9258C15.5057 29.876 15.6166 29.8027 15.71 29.71L18.52 26.89H20V28.33C20 29.1256 20.3161 29.8887 20.8787 30.4513C21.4413 31.0139 22.2044 31.33 23 31.33H29.92L32.29 33.71C32.3834 33.8027 32.4943 33.876 32.6161 33.9258C32.7379 33.9755 32.8684 34.0008 33 34C33.1312 34.0034 33.2613 33.976 33.38 33.92C33.5626 33.845 33.7189 33.7176 33.8293 33.5539C33.9396 33.3901 33.999 33.1974 34 33V23C34 22.2044 33.6839 21.4413 33.1213 20.8787C32.5587 20.3161 31.7956 20 31 20ZM20 23V24.89H18.11C17.9784 24.8892 17.8479 24.9145 17.7261 24.9642C17.6043 25.014 17.4934 25.0873 17.4 25.18L16 26.59V17C16 16.7348 16.1054 16.4804 16.2929 16.2929C16.4804 16.1054 16.7348 16 17 16H27C27.2652 16 27.5196 16.1054 27.7071 16.2929C27.8946 16.4804 28 16.7348 28 17V20H23C22.2044 20 21.4413 20.3161 20.8787 20.8787C20.3161 21.4413 20 22.2044 20 23ZM32 30.59L31 29.59C30.9074 29.4955 30.7969 29.4203 30.6751 29.3688C30.5532 29.3173 30.4223 29.2906 30.29 29.29H23C22.7348 29.29 22.4804 29.1846 22.2929 28.9971C22.1054 28.8096 22 28.5552 22 28.29V23C22 22.7348 22.1054 22.4804 22.2929 22.2929C22.4804 22.1054 22.7348 22 23 22H31C31.2652 22 31.5196 22.1054 31.7071 22.2929C31.8946 22.4804 32 22.7348 32 23V30.59Z"
                  fill="currentColor"
                />
                <template v-if="new_conversation">
                  <path d="M33.25 24C36.0114 24 38.25 21.7614 38.25 19C38.25 16.2386 36.0114 14 33.25 14C30.4886 14 28.25 16.2386 28.25 19C28.25 21.7614 30.4886 24 33.25 24Z" fill="#FF4747" />
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M33.25 15C31.0409 15 29.25 16.7909 29.25 19C29.25 21.2091 31.0409 23 33.25 23C35.4591 23 37.25 21.2091 37.25 19C37.25 16.7909 35.4591 15 33.25 15ZM27.25 19C27.25 15.6863 29.9363 13 33.25 13C36.5637 13 39.25 15.6863 39.25 19C39.25 22.3137 36.5637 25 33.25 25C29.9363 25 27.25 22.3137 27.25 19Z" fill="#FAFAFA" />
                </template>
              </svg>
            </div>
          </div>
          <div class="nav-item group">
            <a class="nav-link cursor-pointer group-hover:text-blue-800 transition-all duration-300 pl-1" href="javascript:;" @click="onShowNoti()">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24Z" fill="#FAFAFA" />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M23.5 14.5714C23.5 15.3368 23.0631 16.0351 22.3748 16.3699C21.2717 16.9065 20.3239 17.7452 19.6382 18.8032C18.9599 19.8497 18.5652 21.0694 18.5 22.3341V26.1428C18.5 26.221 18.4954 26.299 18.4863 26.3766C18.4209 26.9324 18.2918 27.4772 18.1026 28H29.8974C29.7082 27.4772 29.5791 26.9325 29.5137 26.3766C29.5046 26.299 29.5 26.221 29.5 26.1428V22.3341C29.4348 21.0694 29.0401 19.8497 28.3618 18.8032C27.6761 17.7453 26.7282 16.9065 25.6251 16.3699C24.9368 16.0351 24.5 15.3368 24.5 14.5714C24.5 14.4019 24.434 14.2504 24.3338 14.1473C24.2354 14.0461 24.1142 14 24 14C23.8858 14 23.7646 14.0461 23.6662 14.1473C23.566 14.2504 23.5 14.4019 23.5 14.5714ZM31.5 22.2857V26.1428C31.5769 26.7958 31.7745 27.426 32.0809 28C32.1497 28.1288 32.2239 28.2548 32.3035 28.3776C32.7377 29.0476 33.3189 29.6033 34 30H14C14.6811 29.6033 15.2623 29.0476 15.6964 28.3776C15.776 28.2548 15.8502 28.1288 15.919 28C16.2255 27.426 16.4231 26.7958 16.5 26.1428V22.2857C16.5744 20.6542 17.0791 19.0743 17.9599 17.7154C18.8407 16.3564 20.0644 15.2697 21.5 14.5714C21.5 13.8895 21.7634 13.2354 22.2322 12.7531C22.7011 12.2709 23.337 12 24 12C24.663 12 25.2989 12.2709 25.7678 12.7531C26.2366 13.2354 26.5 13.8895 26.5 14.5714C27.9355 15.2697 29.1593 16.3564 30.0401 17.7154C30.9209 19.0743 31.4256 20.6542 31.5 22.2857Z"
                  fill="currentColor"
                />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M20 31V32.25C20 33.2445 20.4214 34.1983 21.1715 34.9016C21.9217 35.6049 22.9391 36 24 36C25.0609 36 26.0783 35.6049 26.8285 34.9016C27.5786 34.1983 28 33.2445 28 32.25V31H26V32.25C26 32.6709 25.8229 33.1029 25.4606 33.4425C25.0938 33.7863 24.5705 34 24 34C23.4295 34 22.9062 33.7863 22.5394 33.4425C22.1771 33.1029 22 32.6709 22 32.25V31H20Z" fill="currentColor" />
                <template v-if="new_notis">
                  <path d="M30.25 25C33.0114 25 35.25 22.7614 35.25 20C35.25 17.2386 33.0114 15 30.25 15C27.4886 15 25.25 17.2386 25.25 20C25.25 22.7614 27.4886 25 30.25 25Z" fill="#FF4747" />
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M30.25 16C28.0409 16 26.25 17.7909 26.25 20C26.25 22.2091 28.0409 24 30.25 24C32.4591 24 34.25 22.2091 34.25 20C34.25 17.7909 32.4591 16 30.25 16ZM24.25 20C24.25 16.6863 26.9363 14 30.25 14C33.5637 14 36.25 16.6863 36.25 20C36.25 23.3137 33.5637 26 30.25 26C26.9363 26 24.25 23.3137 24.25 20Z" fill="#FAFAFA" />
                </template>
              </svg>
            </a>
          </div>
          <div class="nav-item group" v-if="$user.members && $user.members.length">
            <div class="cursor-pointer switch-mode-button mr-3 group-hover:text-blue-800 transition-all duration-300">
              <svg width="48" height="48" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" @click="handleSwitchModeView">
                <rect width="64" height="64" rx="32" fill="#FAFAFA" />
                <path
                  d="M23.4931 39.8632H21.4469V24.8583H32.0867L30.9953 25.9361C30.7386 26.1911 30.5935 26.5376 30.5923 26.8996C30.5909 27.2616 30.7335 27.6094 30.9885 27.8661C31.2437 28.123 31.5902 28.2681 31.9522 28.2693C32.3142 28.2705 32.6618 28.128 32.9187 27.873L36.3288 24.4629C36.4567 24.3361 36.5582 24.1851 36.6275 24.019C36.6968 23.8527 36.7324 23.6743 36.7324 23.4942C36.7324 23.3143 36.6968 23.1359 36.6275 22.9697C36.5582 22.8036 36.4567 22.6526 36.3288 22.5258L32.9187 19.1157C32.6632 18.8616 32.3173 18.719 31.9571 18.719C31.5967 18.719 31.251 18.8616 30.9953 19.1157C30.8675 19.2425 30.7661 19.3933 30.6968 19.5596C30.6276 19.7258 30.592 19.9041 30.592 20.0841C30.592 20.2643 30.6276 20.4424 30.6968 20.6087C30.7661 20.775 30.8675 20.9258 30.9953 21.0526L32.073 22.1303H20.0828C19.721 22.1303 19.3741 22.2739 19.1183 22.5298C18.8625 22.7855 18.7188 23.1326 18.7188 23.4942V41.2273C18.7188 41.5889 18.8625 41.936 19.1183 42.1917C19.3741 42.4476 19.721 42.5912 20.0828 42.5912H23.4931C23.8547 42.5912 24.2018 42.4476 24.4575 42.1917C24.7134 41.936 24.857 41.5889 24.857 41.2273C24.857 40.8655 24.7134 40.5184 24.4575 40.2627C24.2018 40.0068 23.8547 39.8632 23.4931 39.8632ZM44.6361 22.1303H41.226C40.8642 22.1303 40.5173 22.2739 40.2614 22.5298C40.0055 22.7855 39.8619 23.1326 39.8619 23.4942C39.8619 23.856 40.0055 24.2031 40.2614 24.4588C40.5173 24.7147 40.8642 24.8583 41.226 24.8583H43.272V39.8632H31.8547L32.9324 38.7855C33.0603 38.6587 33.1616 38.5079 33.2309 38.3416C33.3002 38.1753 33.3358 37.9971 33.3358 37.817C33.3358 37.6369 33.3002 37.4587 33.2309 37.2925C33.1616 37.1262 33.0603 36.9754 32.9324 36.8486C32.6769 36.5945 32.331 36.4519 31.9706 36.4519C31.6104 36.4519 31.2645 36.5945 31.009 36.8486L27.5989 40.2587C27.4711 40.3855 27.3695 40.5365 27.3002 40.7026C27.231 40.8688 27.1954 41.0472 27.1954 41.2273C27.1954 41.4072 27.231 41.5856 27.3002 41.7519C27.3695 41.9181 27.4711 42.0689 27.5989 42.1957L31.009 45.6058C31.2659 45.8609 31.6135 46.0034 31.9755 46.0022C32.3375 46.001 32.6841 45.8559 32.9392 45.599C33.1942 45.3423 33.3368 44.9945 33.3356 44.6327C33.3342 44.2707 33.1892 43.9239 32.9324 43.6689L31.8547 42.5912H44.6361C44.9979 42.5912 45.3448 42.4476 45.6007 42.1917C45.8564 41.936 46.0002 41.5889 46.0002 41.2273V23.4942C46.0002 23.1326 45.8564 22.7855 45.6007 22.5298C45.3448 22.2739 44.9979 22.1303 44.6361 22.1303Z"
                  fill="currentColor"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
import e3kit from '@/libs/e3kit'
import { debounce } from 'lodash'
import { StreamChat } from 'stream-chat'
import { mapActions, mapGetters } from 'vuex'
import Language from '../../components/Common/Language.vue'
import orgRole from '../../constants/orgRole.js'
import appUtils from '../../utils/appUtils.js'
import { APP_MODE } from '../../utils/constants'
import rolesPermissions from '../../utils/rolesPermissions'
import CodeInvitesClinic from '../CodeInvitesClinic.vue'
import CreateClinic from '../CreateClinic.vue'
import SearchBarHeader from './SearchBarHeader.vue'

export default {
  name: 'NavbarHeader',
  components: { CodeInvitesClinic, CreateClinic, Language, SearchBarHeader },
  props: ['isAdmin', 'isDoctor', 'isClinic', 'extraSidebar'],
  data () {
    return {
      chatMe: null,
      chatClient: this.$chatClient || null,
      test_name: '',
      notifications: [],
      new_notis: false,
      new_conversation: false,
      count_renew: 1,
      clinics: [],
      clinic: null,
      org: null,
      isAdminOrOwner: false,
      userOrg: {},
      appMode: 1,
      pollingNotify: null,
      // search: ''
      options: [],
      value: [],
      list: [],
      loading: false,
      selectedAutocompleteValue: '',
      showHtml: '&hellip;topic     Dermatomal <b>zoster</b> – Reactivation of latent varicella-<b>zoster</b> virus (VZV) infection within the sensory ganglia may result in <b>herpes zoster</b> or "<b>shingles</b>." Uncomplicated <b>herpes zoster</b> typically presents &hellip;',
      dialogVisible: false
    }
  },
  async created () {
    if (Number(this.$route.query.app_mode) === APP_MODE.organization) {
      appUtils.setAppMode(APP_MODE.organization)
      const userInfo = this.$user
      const orgUserOwnerOrAdmin = userInfo?.members?.filter(item => [orgRole.Owner, orgRole.Admin].includes(item?.role))
      appUtils.setGlobalOrg(orgUserOwnerOrAdmin[0].org || {})
    }

    await this.getStreamInstance()
    this.pollNotifyData()
  },
  mounted () {
    // this.getNewNotis()
    if (this.isDoctor) {
      this.getClinics()
    }

    this.handleCheckOwnerOrAdmin()
    this.appMode = this.$appMode
  },
  computed: {
    ...mapGetters({
      upToDateSearchValue: 'upToDate/searchValue'
    }),
    isMobile () {
      return appUtils.checkIsMobile()
    },
    isSafari () {
      return appUtils.checkIsSafari()
    },
    hasUTD () {
      return (this.$featureList && this.$featureList['utd']) || (this.$appMode === APP_MODE.workspace ? this.$featureWsList && this.$featureWsList['utd'] : this.$appMode === APP_MODE.organization ? this.$featureOrgList && this.$featureOrgList['utd'] : false) || false
    },
    hasUTDOrigin () {
      return (this.$featureList && this.$featureList['utd_origin']) || (this.$appMode === APP_MODE.workspace ? this.$featureWsList && this.$featureWsList['utd_origin'] : this.$appMode === APP_MODE.organization ? this.$featureOrgList && this.$featureOrgList['utd_origin'] : false) || false
    },
    HodoUTDDomain () {
      return process.env.VUE_APP_HODO_UPTODATE_DOMAIN
    }
  },
  watch: {
    $route: {
      handler (data) {
        if (data.name === 'HomePage') {
          this.selected = ''
        }
      }
    },
    $user () {
      this.handleCheckOwnerOrAdmin()
    },
    $appMode () {
      this.appMode = this.$appMode
    },
    $globalClinic () {
      this.handleCheckOwnerOrAdmin()
    },
    upToDateSearchValue: {
      handler (data) {
        this.handleSearchChange(data)
      }
    }
  },
  methods: {
    ...mapActions('app', ['refreshE3kitToken']),
    async getStreamInstance () {
      const self = this
      const client = StreamChat.getInstance(process.env.VUE_APP_STREAM_KEY)
      self.chatClient = client
      self.$chatClient = client

      const res = await client.connectUser({ id: String(self.$user.id) }, async () => {
        // make a request to your own backend to get the token
        const response = await self.$rf.getRequest('DoctorRequest').getStreamGenerationToken()
        return response.data?.token
      })

      self.chatMe = res?.me || {}
      self.new_conversation = self.chatMe?.total_unread_count > 0

      // watching unread messages
      client.on(event => {
        if (event.total_unread_count !== undefined) {
          // console.log(event.total_unread_count)
          self.new_conversation = event.total_unread_count > 0
        }

        if (event.unread_channels !== undefined) {
          // console.log(event.unread_channels)
        }
      })

      client.on('notification.message_new', this.handleNotificationEvent)
    },
    async handleNotificationEvent (event) {
      await this.showToast(event)
    },
    async showToast (notification) {
      let self = this
      try {
        const {
          cid,
          channel: { created_by, member_count, name },
          message: { text, user, attachments, mentioned_users }
        } = notification

        // console.log(notification);

        const foundMe = mentioned_users?.findIndex(u => u.id === this.$user.id.toString())

        // Find me in direct or group chat, conditions with member_count
        const pushToMe = (member_count > 2 && foundMe > -1) || (member_count === 2 && user.id !== this.$user.id.toString())

        // console.log(pushToMe)

        if (!pushToMe) return

        try {
          if (window.document.getElementById('noti_sound')) {
            window.document.getElementById('noti_sound').play()
          }
        } catch (error) {}

        const senderId = user.id
        const ownerId = created_by.id

        let textDecrypt = await this.handleDecryptMessage({
          cid,
          text,
          senderId,
          ownerId
        })

        const textMsg = attachments.length ? `<div>🏙 ${this.$t('lbl_sent_an_attached_file')}</div><div>${textDecrypt}</div>` : textDecrypt.includes('/giphy') ? `💬 /${textDecrypt.replace('/giphy ', '')}` : textDecrypt
        self.$toast.default(
          `
          <div>
            <div class="robo-20-500">${name || ''}</div>
            <div class="mb-1 robo-16-500 italic">${user.name}</div>
            <div class="toast-push-notify">${textMsg || ''}</div>
          </div>`,
          {
            position: 'bottom-right',
            duration: 10000,
            onClick () {
              // TODO: Click to Chat & setActive channel with channel data
              console.log('Clicked!!!')
              // self.getNotification(notification_id)
              // if (notification.class === 'App\\\\Circles\\\\IndicationResult') {
              //   const patientVisitId = parseInt(notification.patient_visit_id)
              //   self.$router.push({
              //     name: 'PatientVisitDetail',
              //     params: { id: patientVisitId }
              //   })
              // }
            }
          }
        )
      } catch (e) {
        console.log(e)
      }
    },
    async handleDecryptMessage ({ cid, text, senderId, ownerId }) {
      let textDecrypt = ''
      try {
        const groupId = `group_${cid}`
        const groupCard = await e3kit.getGroupCardData(groupId, ownerId)
        const senderCard = await e3kit.findUsers(senderId)

        if (text && groupCard) {
          textDecrypt = await e3kit.groupDecrypt(text, groupId, senderCard, ownerId, groupCard)
        }
      } catch (error) {
        console.log(error)
        if (error.message === 'JWT is expired') {
          // Refresh Encryption Token
          await this.refreshE3kitToken()
          await this.handleDecryptMessage({ cid, text, senderId, ownerId })
        }
      }

      return textDecrypt
    },
    focusUpToDateSearch (e) {
      this.$refs.upToDateSearch.focus()
    },
    onShowModalOpitonClinic (show) {
      window.$('#modal__option').modal(show ? 'show' : 'hide')
    },
    onOpenCodeInvites () {
      let self = this
      self.onShowModalOpitonClinic(false)
      self.onShowModalJoin(true)
    },
    showCreate () {
      let self = this
      self.onShowModalOpitonClinic(false)
      self.onShowModalCreate(true)
    },
    handleClose (done) {
      this.$confirm('Are you sure to close this dialog?')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    handleChangePage: debounce(function (value) {
      this.handleSearchChange(value)
    }, 200),
    async handleSetSlugRoute () {
      this.$store.commit('upToDate/setSearchValue', this.selectedAutocompleteValue)
      this.$router
        .push({
          path: '/doctor/searchbar',
          query: { slug: this.selectedAutocompleteValue }
        })
        .catch(() => {})
    },
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.handleSearchChange(query)
        }, 200)
      } else {
        this.options = []
      }
    },
    changeLanguage (lang) {
      if (lang === 'vi') {
        this.$lang = 'vi'
      } else if (lang === 'en') {
        this.$lang = 'en'
      }
    },
    changeDoctor () {
      this.form.cr_id = ''
      this.timeslots = []
      this.getConsultingRooms(this.form.doctor_id)
      this.timeSlotStartTime = null
      console.log('change doctor')
    },
    onSubmit () {
      console.log('submit!')
    },
    joinClinic () {
      this.$router
        .push({
          name: 'DontHaveClinic',
          query: { type: 'join', t: new Date().valueOf() }
        })
        .catch(() => {})
    },
    createClinic () {
      this.$router
        .push({
          name: 'DontHaveClinic',
          query: { type: 'create', t: new Date().valueOf() }
        })
        .catch(() => {})
    },
    onShowNoti () {
      this.new_notis = false
      this.$emit('onShowNoti', true)
    },
    getImageURL (avatar) {
      return appUtils.getImageURL(avatar)
    },
    async getNewNotis () {
      let self = this
      if (this.$user) {
        if (self.isDoctor) {
          try {
            let resp = await self.$rf.getRequest('DoctorRequest').getNewNotifications()
            if (resp && resp.data.count > 0) {
              self.new_notis = true
            } else {
              self.new_notis = false
            }
          } catch (e) {
            // statements
            console.log(e)
          }
        } else if (self.isAdmin) {
          try {
            let resp = await self.$rf.getRequest('AdminRequest').getNewNotifications()
            if (resp && resp.data.count > 0) {
              self.new_notis = true
            } else {
              self.new_notis = false
            }
          } catch (e) {
            // statements
            console.log(e)
          }
        }
      }
    },
    pollNotifyData () {
      this.pollingNotify = setInterval(this.getNewNotis, 30000)
    },
    onOpenSidebar () {
      this.$emit('onOpenSidebar')
    },
    async getClinics () {
      let self = this
      await self.$rf
        .getRequest('DoctorRequest')
        .getClinic()
        .then(resp => {
          // gán data trả về
          if (resp.data?.length) {
            self.clinics = resp.data
            let first_clinic = resp.data[0]

            if (!this.$clinicId && !this.$globalOrg) {
              appUtils.setDoctorClinic(first_clinic)
              this.setOrg(first_clinic)
              self.getDoctorPermissions(first_clinic.id)
            } else {
              if (this.$clinicId) {
                let cli = resp.data?.find(c => c.id === this.$clinicId)
                if (cli) {
                  appUtils.setDoctorClinic(cli)
                  this.setOrg(cli)
                  self.getDoctorPermissions(cli.id)
                } else {
                  appUtils.setDoctorClinic(first_clinic)
                  this.setOrg(first_clinic)
                  self.getDoctorPermissions(first_clinic.id)
                }
              }
            }

            if (self.$globalOrg) {
              self.clinic = self.clinics?.find(item => {
                return item.organization?.id === self.$globalOrg.id
              })
            }
          } else {
            appUtils.removeClinicId()
            appUtils.removeDoctorClinic()
            if (self.$route.meta.requiredWs) {
              // eslint-disable-next-line standard/computed-property-even-spacing
              const msg = this.$t('workspace_setting.lbl_need_ws_msg')[this.$orgModel]
              self.$toast.open({
                message: msg,
                type: 'success'
              })
              self.$router.push({ path: '/workspace' }).catch(() => {})
            }
          }
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {})
    },

    async getDoctorPermissions (id) {
      let self = this
      let user = this.$user
      if (!user.doctor) return
      let params = {}
      await self.$rf
        .getRequest('DoctorRequest')
        .getWorkspaceRolePermissions(id, params)
        .then(resp => {
          if (resp.data) {
            let role = resp.data.role
            if (role) {
              let new_role = {
                id: role.id,
                name: role.name,
                workspace_id: role.workspace_id
              }
              rolesPermissions.setRole(new_role)
              role.permissions ? rolesPermissions.setPermissionsList(role.permissions) : rolesPermissions.setPermissionsList([])
            } else {
              this.removeRP()
            }
          } else {
            this.removeRP()
          }
        })
        .catch(e => {
          console.log(e)
          this.removeRP()
        })
        .finally(() => {})
    },
    removeRP () {
      rolesPermissions.setRole(null)
      rolesPermissions.setPermissionsList([])
    },
    switchClinic (clinic) {
      let self = this
      // let o = !!this.$globalOrg
      if (clinic) {
        self.$message({
          message: 'Chuyển thành công',
          type: 'success'
        })
        setTimeout(() => {
          this.$router.replace({ path: '/' }).catch(_ => {})
        }, 200)
        appUtils.removeGlobalOrg()
        appUtils.setDoctorClinic(clinic)
        this.setOrg(clinic)
      }
    },
    switchOrg (org) {
      let self = this
      // let c = this.$globalClinic
      if (org) {
        const orgSelectedInfo = self.$user?.members.find(item => item?.org_id === org?.id) || {}
        const isOwnerOrAdmin = [orgRole.Admin, orgRole.Owner].includes(orgSelectedInfo.role)
        if (!isOwnerOrAdmin) {
          self.$message({
            message: 'Bạn không có quyền truy cập tổ chức này',
            type: 'warning'
          })
          return
        }

        self.$message({
          message: 'Chuyển thành công',
          type: 'success'
        })
        appUtils.setGlobalOrg(orgSelectedInfo.org)
        this.userOrg = orgSelectedInfo.org
        setTimeout(() => {
          self.$router.push({ name: 'OrganizationManagement' }).catch(_ => {})
        }, 200)
      }
    },
    switchMode (data) {
      const self = this
      if (self.appMode === 1) {
        self.switchClinic(data)
      } else if (self.appMode === 2) {
        self.switchOrg(data.org)
        // self.handleCheckOwnerOrAdmin()
      }
    },
    async handleSwitchModeView () {
      const userInfo = this.$user
      const appMode = Number(appUtils.getAppMode())
      if (appMode === APP_MODE.workspace) {
        this.$router.push({ name: 'OrganizationManagement' }).catch(_ => {})
        appUtils.setAppMode(APP_MODE.organization)
        if (this.$globalOrg) {
          appUtils.setGlobalOrg(this.$globalOrg)
        } else if (userInfo) {
          // const globalOrg = this.$globalClinic?.organization
          // const orgInMembersOrg = userInfo?.members?.find(
          //   m => m?.org_id === globalOrg?.id
          // )
          // appUtils.setGlobalOrg(
          //   orgInMembersOrg?.org || userInfo?.members[0]?.org
          // )
          const orgUserOwnerOrAdmin = userInfo?.members?.filter(item => [orgRole.Owner, orgRole.Admin].includes(item?.role))
          appUtils.setGlobalOrg(orgUserOwnerOrAdmin[0].org || {})
        }
      } else {
        this.$router.replace({ path: '/' }).catch(_ => {})
        appUtils.setAppMode(APP_MODE.workspace)
        appUtils.removeGlobalOrg()
        await this.getClinics()
      }

      await this.getAuthMe()
    },
    setOrg (clinic) {
      if (clinic.organization && clinic.organization?.owner_id === this.$user?.id) {
        this.org = clinic.organization
        this.clinic = clinic
      }
    },
    handleCheckOwnerOrAdmin () {
      const userInfo = appUtils.getLocalUser()
      if (userInfo) {
        const globalOrg = this.$globalClinic?.organization || this.$globalOrg
        const orgInMembersOrg = userInfo?.members?.find(m => m?.org_id === globalOrg?.id)

        const orgUserOwnerOrAdmin = userInfo?.members?.filter(item => [orgRole.Owner, orgRole.Admin].includes(item?.role))

        this.userOrg = (Boolean(orgInMembersOrg) && globalOrg) || userInfo?.members?.[0].org || {}
        // this.userOrg =
        //   orgUserOwnerOrAdmin?.[0]?.org ||
        //   (Boolean(orgInMembersOrg) && globalOrg) ||
        //   userInfo?.members?.[0].org ||
        //   {}

        // const isOwnerOrAdmin = [orgRole.Owner, orgRole.Admin].some(el =>
        //   userInfo?.members?.map(m => m.role).includes(el)
        // )
        const isOwnerOrAdmin = orgUserOwnerOrAdmin?.length > 0
        this.isAdminOrOwner = isOwnerOrAdmin
        return isOwnerOrAdmin
      }
    },
    async getAuthMe () {
      await this.$rf
        .getRequest('AuthRequest')
        .me()
        .then(res => {
          appUtils.setLocalUser(res.data)
        })
    },
    async handleSearchChange (query) {
      const self = this
      try {
        if (query !== '') {
          const params = {
            keyword: query,
            limit: 10
          }
          const result = await self.$rf.getRequest('DoctorRequest').getSearchResult(params)

          this.options = result.data.data.searchTerms
          self.loading = false
        } else {
          this.options = []
          this.selectedAutocompleteValue = ''
        }
      } catch (error) {
        console.log('', error)
      } finally {
        self.loading = false
      }
    },
    goToConversation () {
      const domain = window.location.hostname === 'localhost' ? 'http://localhost:3000' : process.env.VUE_APP_HODO_CONVERSATION
      const routeRaw = `${domain}/redirect.html?token=${appUtils.getLocalToken()}&lang=${this.$lang}`

      console.log(routeRaw)

      if (appUtils.checkIsMobile()) {
        let linkElement = document.createElement('a')
        const linkId = `conversation_id_${appUtils.randomStr(6, true)}`
        linkElement.id = linkId
        linkElement.href = routeRaw
        window.document.body.appendChild(linkElement)

        const linkEl = document.getElementById(linkId)
        linkEl.setAttribute('rel', 'noopener noreferrer')
        !appUtils.checkIsMobile() && linkEl.setAttribute('target', '_blank')
        linkEl.click()
        linkEl.remove()
        return
      }

      window.open(routeRaw, '_blank')
    }
  },
  beforeDestroy () {
    clearInterval(this.pollingNotify)
  },
  destroyed () {
    this.chatClient.disconnectUser()
  }
}
</script>
<style scoped>
.sidebar-toggle {
  width: 56px;
}

.sidebar-toggle.open {
  @media screen and (min-width: 720px) {
    width: 240px;
    margin-left: 0.5rem;
  }
}

.btn-join-ws {
  width: 170px;
  height: 30px;
  font-weight: 400;
}

.bg-fa {
  background-color: #fafafa;
}

.hodo-navbar {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1031;
  width: 100%;
  transition: width 0.3s linear;
}

.change-ws {
  width: 100%;
  height: 48px;
  max-width: 224px;
  border-radius: 16px;
  padding: 8px;
  display: flex;
  align-items: center;
  text-decoration: none;
  background-color: #fafafa;
}

.brand-wraper {
  display: flex;
  align-items: center;
  transition: all ease-in-out 0.3s;
}

.fliped {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}

.navbar-brand,
.visible,
.invisible {
  transition: visibility 0.3s linear;
}

.navbar-brand.hide {
  display: none;
}

.navbar-brand.show {
  display: flex;
}

.modal {
  z-index: 9999;
}

.relative {
  position: relative;
}

.icon-open-change-ws {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  right: 0;
}

.w-180px {
  width: 180px !important;
}

.w-500px {
  width: 565px !important;
}

.h-sw {
  max-height: calc(100vh - 30px);
}

.visible {
  visibility: visible;
}

.invisible {
  visibility: hidden;
}

.switch-mode-button {
  /* position: fixed;
  top: 10px;
  right: 10px; */
}

.noti-mode-button {
  /* position: fixed;
  top: -6px;
  right: 44px; */
}

/* search bar style */
.typing {
  width: 70%;
}

.typing /deep/ .el-input__prefix {
  left: auto;
  right: 5px;
}

.typing /deep/ .el-input__suffix {
  right: 60px;
}

.typing /deep/ .el-input--prefix .el-input__inner {
  padding-left: 8px;
}

.typing /deep/ .el-input--suffix .el-input__inner {
  padding-right: 60px;
}

.typing /deep/ .el-input__inner {
  border: 1px solid transparent !important;
  transition: all 0.3s ease;
}

.typing /deep/ .el-input__inner:focus {
  border: 1px solid #20429b !important;
  box-shadow: 0 0 5px 0px #20429b !important;
}

/* search bar style */
</style>
